import React from 'react';

const Modal = ({
   isOpen,
   onClose,
   title,
   children,
   maxWidth = 'max-w-md',
   allowOverflow = false,
}) => {
   if (!isOpen) return null;

   return (
      <div className="fixed inset-0 z-50 flex items-center justify-center">
         <div className="fixed inset-0 backdrop-blur-[1.5px] bg-[#25223D4D]" onClick={onClose} />
         <div
            className={`relative bg-white dark:bg-dark-secondary rounded-lg shadow-xl p-6 w-full ${maxWidth} mx-4 max-h-[90vh] ${allowOverflow ? '' : 'overflow-y-auto'} [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]`}
         >
            <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100 mb-4">{title}</h3>
            {children}
         </div>
      </div>
   );
};

export default Modal;
